import React from 'react'
import {Marker, InfoWindow} from '@react-google-maps/api'
import gql from 'graphql-tag'
import moment from 'moment'
import Link from 'components/shared/Link'

import marker from 'assets/icons/map-marker.svg'
import markerWithKeyPickup from 'assets/icons/map-marker-with-key-pickup.svg'
import BookingListItemProducts from '../BookingListItemProducts'

const BookingMarker = ({booking, label, expanded, onExpand, onClose}) => {
  const {id, startsAt} = booking
  const {streetAddress, location} = booking.estate

  if (!location) return null

  const hasKeyPickup = !!booking.pickUpKeysInstructions
  const mapMarker = hasKeyPickup ? markerWithKeyPickup : marker

  return (
    <Marker
      position={location}
      onClick={onExpand}
      label={{text: label, color: 'white'}}
      icon={mapMarker}
    >
      {expanded &&
        <InfoWindow position={location} onCloseClick={onClose}>
          <div>
            <div>
              <Link to={`/bookings/${id}`}>{streetAddress}</Link>
            </div>
            <div>
              {moment(startsAt).format('Do MMM [kl.]HH:mm')}
            </div>
            <BookingListItemProducts booking={booking} iconSize={16} />
          </div>
        </InfoWindow>
      }
    </Marker>
  )
}

BookingMarker.fragments = {
  bookingMarker: gql`
    fragment BookingMarker on Booking {
      id
      startsAt
      estate {
        id
        streetAddress
      }
    }
  `,
}

export default BookingMarker
